module.exports = __webpack_public_path__ + "img/fi-rr-cloud.cb6a4d2a.svg";